import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import {CoachingReviewTypeDisplay} from 'components/dashboard/common/CoachingReviewTypeDisplayAndChooser';
import Button from '@material-ui/core/Button';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingStatsStore from 'stores/coaching/CoachingStatsStore';
import CoachingStatsActions from 'actions/coaching/CoachingStatsActions';
import pluralize from 'pluralize';
import {ReviewLink} from 'components/dashboard/admin/ReviewLink';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';
import {LocationDotIcon} from '@components/icon/LocationDotIcon';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';

@connectToStores
export default class ReviewTooltip extends React.PureComponent {
  static getStores() {
    return [CoachingStatsStore];
  }

  static getPropsFromStores(props) {
    return {
      ...CoachingStatsStore.getState(),
    };
  }

  componentDidMount() {
    CoachingStatsActions.coachingStats.defer(this.props.plan.id);
  }

  getSkillsWithStatsForDisplay = (reviewId, plan, coachingStats) =>
    plan.contentDetails
      .map(detail => {
        const score = coachingStats.chart[detail.id]?.reviewScores.find(
          r => r.reviewId === reviewId
        )?.score;
        return `${detail.skillName ?? detail.custom}${score ? ` (${score}%)` : ''}`;
      })
      .join(', ');

  render() {
    const {adminId, managerId, review, plan, fromPath, reviewTypes, coachingStats} = this.props;
    const reviewType = reviewTypes.get(review.reviewTypeId);
    const skillsForDisplay =
      coachingStats && this.getSkillsWithStatsForDisplay(review.id, plan, coachingStats);
    return (
      <div className="admin-dash-tooltip">
        <div className="user-avatar">
          <UserAvatar user={plan.recipient.info} />{' '}
          <span>Met with {plan.recipient.info.firstName}</span>
        </div>
        <div>
          <div>
            <strong>Coach:</strong> {plan.coach.info.getFullName()}
          </div>
          <div>
            <strong>Recipient:</strong> {plan.recipient.info.getFullName()}
          </div>
        </div>
        {coachingStats && (
          <div className="skills">
            <span>
              <strong>{pluralize('Skill', plan.contentDetails.size)}:</strong> {skillsForDisplay}
            </span>
          </div>
        )}
        {reviewType && <CoachingReviewTypeDisplay reviewType={reviewType} />}
        <div className="completed">
          <CalendarDaysIcon tooltip="Time" />
          {review.completedAt.format('ddd, M/D/YY, h:mmA')}
        </div>
        <div className="location">
          <LocationDotIcon tooltip="Location" />
          {(review.meetingType && review.meetingType.detail()) || 'Virtual meeting'}
        </div>
        <ReviewLink
          adminId={adminId}
          managerId={managerId}
          review={review}
          plan={plan}
          fromPath={fromPath}>
          <ThemeProvider theme={lightTheme}>
            <Button variant="outlined" className="ev-button">
              View Meeting Notes
            </Button>
          </ThemeProvider>
        </ReviewLink>
      </div>
    );
  }
}
